'use strict';
'use es6';

// eslint-disable-next-line no-unused-vars

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NonEmptyString;
function NonEmptyString(props, propName, componentName, location) {
  var value = props[propName];
  if (!(typeof value === 'string' && value.length > 0)) {
    return new Error('Invalid prop `' + propName + '` supplied to ' + componentName + ', expected ' + ('a non-empty string, received `' + value + '`'));
  }
  return null;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.43/js/propTypes/NonEmptyString.js
// module id = 195
// module chunks = 0